import classNames from 'classnames'
import type { ReactNode } from 'react'
import styles from './Page.module.css'

interface PageProps {
  children: ReactNode
  width?: 'narrow' | 'medium' | 'wide'
  className?: string
}

function PageTitle({ children }: { children: ReactNode }) {
  return <h1 className={styles['title']}>{children}</h1>
}

function PageTitleRow({ children }: { children: ReactNode }) {
  return <div className={styles['titleRow']}>{children}</div>
}

function PageTitleGroup({ children }: { children: ReactNode }) {
  return <div className={styles['titleGroup']}>{children}</div>
}

function PageFilterRow({ children }: { children: ReactNode }) {
  return <div className={styles['filterRow']}>{children}</div>
}

function PageFilterDivider() {
  return <div className={styles['filterDivider']} />
}

export function Page({ children, width, className }: PageProps) {
  return (
    <div
      className={classNames(
        styles['page'],
        width === 'narrow' && styles['narrow'],
        width === 'medium' && styles['medium'],
        width === 'wide' && styles['wide'],
        className,
      )}
    >
      {children}
    </div>
  )
}

Page.Title = PageTitle
Page.TitleRow = PageTitleRow
Page.TitleGroup = PageTitleGroup
Page.FilterRow = PageFilterRow
Page.FilterDivider = PageFilterDivider
